<template>
  <div class="inner">
    <div class="page_con">
      <div class="inform_box mb30">
        <ol class="ol dot">
          <li class="grey">
            <span class="ol_li_txt">크롬(chrome)브라우저에서 원활한 강의 수강 및 수료증 출력이 가능합니다.</span>
          </li>
          <li class="grey">
            <span class="ol_li_txt">강의와 더불어 교육평가시험과 설문조사까지 참여해주셔야 수강완료로 인정되며, 수료증 출력이 가능합니다.</span>
          </li>
          <li class="grey">
                            <span class="ol_li_txt">
                                위생관리자의 경우 수강 완료 전 지정확인서를 미리 제출했는지 확인하세요.
                                <router-link to="/edu/hygiene/list" class="txt_btn">지정확인서 제출하기</router-link>
                            </span>
          </li>
        </ol>
      </div>
      <div class="rule_list_ttl center">
        <h3 class="h3">{{ form.info.businessName }}</h3>
      </div>
      <div class="m_table">
        <ul class="m_table_ul">
          <li class="m_table_li" v-for="(item, index) in list" :key="index">
            <div class="col">
              <div class="tag" :class="item.status === 1 ? 'color' : 'light_grey'">
                <span>{{ item.status === 1 ? '수강' : '미수강'  }}</span>
              </div>
              <div class="m_table_ttl">
                <!-- 한국외식산업협회 위생교육 수강 페이지 강의명 하이라이트 (서남아이에스 임현아, 2024-08-30) -->
                <span>[</span>
                <span v-if="item.isChoice === 1 " style="color:red">필수</span>
                <!-- <span v-else-if="item.isChoice === 2 " style="color:green">선택</span> -->
                <span v-else-if="item.isChoice === 2 " style="color:grey">자율선택</span>
                <span v-else><span style="color:red">필수</span><span style="color:blue">선택</span></span>
                <span style="margin-right: 0.5rem;">]</span>
                <span style="font-weight: 700;">{{item.className}}</span>
                <!-- <span>{{ `[${item.isChoice === 1 ? '필수' : item.isChoice === 2 ? '선택': '필수(선택)'}] ${item.className}` }}</span> -->
              </div>
              <div class="dl">
                <span class="dt">학습시간</span>
                <span class="dd">{{ $Util.isEmpty(item.studyTime) ? '' : $Util.secondsToTimes2(item.studyTime) }}</span>
                <span class="dt">/ 강의 총시간</span>
                <span class="dd">{{ item.classTime }}</span>
              </div>
            </div>
            <div class="col fix110">
              <!-- 찾아가는 위생 교육 | 교육 구분 표출 변경 (서남아이에스 임현아, 2024-08-08) -->
              <!-- <button class="btn bo"
                      v-if="!$Util.isEmpty(form.code) && form.code.code !== 999"
                      :disabled="item.status === 2 && item.isChoice !== 2"
                      @click="fnVideo(item.onlineClassNo, item.onlineEduNo)"
              >수강하기</button> -->
              <button class="btn bo"
                      v-if="!$Util.isEmpty(form.code) && form.code.code !== 999"
                      @click="fnVideo(item.onlineClassNo, item.onlineEduNo)"
              >수강하기</button>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <top-button />
  </div>
</template>

<script>
import TopButton from '@/components/pages/top/button'
export default {
  name: 'study-room-index',
  components: {TopButton},
  data() {
    return {
      form: {},
      list: [],
      education: {},
      params: {
        onlineClassNo: -1,
        onlineEduNo: -1,
        ipAddress: '',
        studyTime: '',
        status: 2,
        isStart: 0
      },
      currentIndex: 1
    }
  },
  async created() {
    const onlineEduNo = this.$route.query
    const res = await this.$OnlineEduSvc.fetchData(onlineEduNo)
    if (res.code === 1) {
      this.form = res.entity
      this.list = res.entity.class
    }
  },
  computed: {
    userData: function() {
      console.log(this.$store.getters['user/getUserData'])
      return this.$store.getters['user/getUserData']
    },
    // 강의상태(1:수료, 2:미수료)가 미수료일경우 리턴 false (버튼 활성화)
    classStatus: function() {
      let classStatus = 0
      this.list.forEach(item => {
        if(item.status === 2) {
          classStatus++
        }
      })
      return classStatus
    }
  },
  methods: {
    fnView: function(path) {
      this.$router.push({
        path: path,
        query: {onlineEduNo: this.form.info.onlineEduNo, rUrl: this.$route.fullPath}
      })
    },
    fnBoard: function(path, boardType) {
      this.$store.commit('education/setBoardType', { boardData: { boardType: boardType } })
      this.$router.push({ path: path })
    },
    fnVideo: function (onlineClassNo, onlineEduNo) {
      const option = "width=640, height=360, scrollbars, resizable"
      this.$windowOpenPop(`${this.$ConstCode.CODE_ENV_LIST.WEB_URL}/edu/replay/video?onlineClassNo=${onlineClassNo}&onlineEduNo=${onlineEduNo}`, this, option)
      // this.$windowOpenPop(`https://m.kfoodedu.or.kr/edu/replay/video?onlineClassNo=${onlineClassNo}&onlineEduNo=${onlineEduNo}`, this, option)
      // this.$windowOpenPop(`http://1.201.137.124:58203/edu/replay/video?onlineClassNo=${onlineClassNo}&onlineEduNo=${onlineEduNo}`, this, option)
      let test = window.setInterval(() => {
        try {
          if ( this.$open == null ||  this.$open.closed) {
            this.fnUpdate()
            this.fetchData()
            window.clearInterval(test)
          }
        } catch (e) {
          console.log('ddd')
        }
      }, 500)
    },
    fetchData: async function () {
      const params = {}
      params.onlineEduNo = this.form.info.onlineEduNo
      const res = await this.$OnlineEduSvc.fetchData(params)
      if (res.code === 1) {
        this.form = res.entity
        this.list = res.entity.class
      }
    }
  }
}
</script>

<style scoped>

</style>
